module.exports = __webpack_public_path__ + "static/grafika4-c087b307e5482b6260445140bf10e4a4.png";